<template>
  <div
    :class="sidebarbg"
    class="app-sidebar sidebar-shadow"
    @mouseover="toggleSidebarHover('add', 'closed-sidebar-open')"
    @mouseleave="toggleSidebarHover('remove', 'closed-sidebar-open')"
  >
    <div class="app-header__logo">
      <span style="color: white; font-size: 2em;">Bluespend</span>
      <div class="header__pane ml-auto">
        <button
          type="button"
          class="hamburger close-sidebar-btn hamburger--elastic"
          v-bind:class="{ 'is-active': isOpen }"
          @click="toggleBodyClass('closed-sidebar')">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
    <div class="app-sidebar-content">
      <VuePerfectScrollbar class="app-sidebar-scroll">
        <sidebar-menu
          ref="prueba"
          showOneChild
          :menu="menu"
          @item-click="onItemClick"
          v-if="filtered"
        />
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { SidebarMenu } from 'vue-sidebar-menu'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import {
  faCog,
  faCogs,
  faBusinessTime,
  faSearch,
  faStar,
  faHome,
  faUser,
  faUsers,
  faBuilding,
  faFileInvoiceDollar,
  faHandHoldingUsd,
  faMoneyBill,
  faMoneyCheckAlt,
  faFileAlt,
  faFileDownload,
  faBell,
  faPowerOff,
  faEnvelope,
  faWallet,
  faExclamationTriangle,
  faTasks,
  faPaperclip,
  faHandshake,
  faPlaneDeparture,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faCog,
  faCogs,
  faBusinessTime,
  faSearch,
  faStar,
  faHome,
  faUser,
  faUsers,
  faBuilding,
  faFileInvoiceDollar,
  faFileAlt,
  faFileDownload,
  faBell,
  faPowerOff,
  faEnvelope,
  faWallet,
  faExclamationTriangle,
  faTasks,
  faPaperclip,
  faHandshake,
  faPlaneDeparture,
  faHandHoldingUsd,
  faMoneyBill,
  faMoneyCheckAlt,
  faQuestion
)
dom.watch()

export default {
  components: {
    SidebarMenu,
    VuePerfectScrollbar,
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      userLogged: {
        roles: [
          {
            permissions: '',
          },
        ],
      },
      menu: [],
      filtered: false,
      isOpen: false,
      sidebarActive: false,
      collapsed: true,
      windowWidth: 0,
    }
  },
  props: {
    sidebarbg: String,
  },
  computed: {
    // Los módulos de solicitud de caja chica (solicitar y validar) sólo se
    // muestran si la empresa tiene activo el feature PETTY_CASH_REQUESTS.
    applyFeaturePettyCashRequests() {
      if (this.userLogged.company === undefined) {
        return false
      }

      const features = this.userLogged.company[0].features || []

      if (features.find((x) => x.name === 'PETTY_CASH_REQUESTS')) {
        return true
      }

      return false
    },
    // menuR() {
    //   return [
    //     {
    //       icon: 'fa fa-home',
    //       title: this.$t('general.home'),
    //       href: '/dashboard',
    //     },
    //     {
    //       icon: 'fa fa-bell',
    //       title: this.$t('general.notifications'),
    //       href: '/notifications',
    //     },
    //     {
    //       class: 'hidden',
    //       icon: 'fa fa-envelope',
    //       title: this.$t('general.contacts'),
    //       href: '/contact',
    //     },
    //     {
    //       class: '',
    //       icon: 'fa fa-building',
    //       title: this.$t('general.companyOptions'),
    //       child: [
    //         {
    //           id: 5,
    //           class: 'hidden',
    //           title: this.$t('general.companies'),
    //           icon: 'business',
    //           href: '/companies',
    //         },
    //         {
    //           id: 9,
    //           class: 'hidden',
    //           title: this.$t('general.subscriptions'),
    //           icon: 'local_atm',
    //           href: '/subscriptions',
    //         },
    //         {
    //           id: 11,
    //           class: 'hidden',
    //           title: this.$t('general.areas'),
    //           icon: 'group_work',
    //           href: '/areas',
    //         },
    //         {
    //           id: 10,
    //           class: 'hidden',
    //           title: this.$t('general.branches'),
    //           icon: 'store_mall_directory',
    //           href: '/branches',
    //         },
    //         {
    //           id: 15,
    //           class: 'hidden',
    //           title: this.$t('general.projects'),
    //           icon: 'folder_open',
    //           href: '/projects',
    //         },
    //         {
    //           id: 12,
    //           class: 'hidden',
    //           title: this.$t('general.categories'),
    //           icon: 'category',
    //           href: '/categories',
    //         },
    //         {
    //           id: 32,
    //           class: 'hidden',
    //           title: this.$t('travelTypes.name'),
    //           href: '/travelTypes',
    //         },
    //         {
    //           id: 13,
    //           class: 'hidden',
    //           title: this.$t('general.restrictions'),
    //           // icon: 'warning',
    //           href: '/restrictions',
    //         },
    //         {
    //           id: 14,
    //           class: 'hidden',
    //           title: this.$t('general.workflow'),
    //           icon: 'timeline',
    //           href: '/workflow',
    //         },
    //         {
    //           id: 29,
    //           class: 'hidden',
    //           title: this.$t('general.keywords'),
    //           icon: 'stars',
    //           href: '/keywords',
    //         },
    //         {
    //           id: 29,
    //           class: 'hidden',
    //           title: this.$t('vehicles.vehicles'),
    //           icon: 'stars',
    //           href: '/vehicles',
    //         },
    //       ],
    //     },
    //     {
    //       class: '',
    //       icon: 'fa fa-user',
    //       title: this.$t('general.userOptions'),
    //       child: [
    //         {
    //           id: 2,
    //           class: 'hidden',
    //           title: this.$t('general.users'),
    //           icon: 'users',
    //           href: '/users',
    //         },
    //         // {
    //         //   id: 1,
    //         //   class: 'hidden',
    //         //   icon: 'contacts',
    //         //   title: this.$t('general.userApplication'),
    //         //   href: '/user-application'
    //         // },
    //         {
    //           id: 3,
    //           class: 'hidden',
    //           title: this.$t('general.roles'),
    //           icon: 'user',
    //           href: '/roles',
    //         },
    //         {
    //           id: 4,
    //           class: 'hidden',
    //           title: this.$t('general.permissions'),
    //           icon: 'security',
    //           href: '/permissions',
    //         },
    //         {
    //           id: 6,
    //           class: 'hidden',
    //           title: this.$t('general.validators'),
    //           icon: 'how_to_reg',
    //           href: '/validators',
    //         },
    //         {
    //           id: 7,
    //           class: 'hidden',
    //           title: this.$t('general.substitutes'),
    //           icon: 'loop',
    //           href: '/substitutes',
    //         },
    //         {
    //           id: 8,
    //           class: 'hidden',
    //           title: this.$t('general.approver'),
    //           icon: 'person',
    //           href: '/approver',
    //         },
    //         {
    //           id: 19,
    //           class: 'hidden',
    //           title: this.$t('cashier.name'),
    //           icon: 'credit_card',
    //           href: '/cashier',
    //         },
    //       ],
    //     },
    //     {
    //       class: '',
    //       icon: 'fa fa-hand-holding-usd',
    //       title: this.$t('general.myExpensesNew'),
    //       child: [
    //         {
    //           id: 16,
    //           class: 'hidden',
    //           title: this.$t('general.expenses'),
    //           icon: 'attach_money',
    //           href: '/expenses',
    //         },
    //         {
    //           id: 21,
    //           class: 'hidden',
    //           title: this.$t('general.rejected'),
    //           href: '/rejected_expenses',
    //         },
    //         // {
    //         //   id: 19,
    //         //   class: 'hidden',
    //         //   title: this.$t('general.approbed'),
    //         //   href: '/approved_expenses',
    //         // },
    //         {
    //           id: 17,
    //           class: 'hidden',
    //           title: this.$t('general.history'),
    //           icon: 'history',
    //           href: '/history',
    //         },
    //       ],
    //     },
    //     {
    //       class: '',
    //       icon: 'fa fa-file-invoice-dollar',
    //       title: this.$t('viatics.title'),
    //       href: '/expensesRequest',
    //     },
    //     {
    //       // id: 20,
    //       icon: 'far fa-check-circle',
    //       class: 'hidden',
    //       title: this.$t('general.check'),
    //       // href: '/validate_expenses',
    //       child: [
    //         {
    //           id: 20,
    //           class: 'hidden',
    //           title: this.$t('general.validateExpenses'),
    //           href: '/validate_expenses',
    //         },
    //         {
    //           id: 40,
    //           class: 'hidden',
    //           title: this.$t('general.validateRequest'),
    //           href: '/approvals/validate-request',
    //         },
    //       ],
    //     },
    //     {
    //       class: '',
    //       title: this.$t('general.expenseOptions'),
    //       icon: 'fa fa-money-check-alt',
    //       child: [
    //         {
    //           id: 34,
    //           class: 'hidden',
    //           title: this.$t('pettyCash.title'),
    //           icon: 'attach_money',
    //           href: '/pettyCash',
    //         },
    //         {
    //           id: 32,
    //           class: 'hidden',
    //           title: this.$t('general.advances'),
    //           icon: 'attach_money',
    //           href: '/advances',
    //         },
    //         {
    //           id: 28,
    //           class: 'hidden',
    //           title: this.$t('general.payable'),
    //           href: '/expensesPayable',
    //         },
    //         {
    //           id: 30,
    //           class: 'hidden',
    //           title: this.$t('ExpensesPaid.name'),
    //           href: '/expensesPaid',
    //         },
    //         {
    //           id: 39,
    //           class: 'hidden',
    //           title: this.$t('expenses.reservations.title'),
    //           href: '/reservations',
    //         },
    //       ],
    //     },
    //     {
    //       icon: 'fa fa-handshake',
    //       title: this.$t('general.conciliations'),
    //       class: '',
    //       child: [
    //         {
    //           id: 35,
    //           class: 'hidden',
    //           title: this.$t('conciliation.status.toConciliate'),
    //           href: '/toReconcileExpenses',
    //         },
    //         {
    //           id: 36,
    //           class: 'hidden',
    //           title: this.$t('conciliation.status.conciliated'),
    //           href: '/reconciledExpenses',
    //         },
    //         {
    //           id: 37,
    //           class: 'hidden',
    //           title: this.$t('conciliation.status.excluded'),
    //           href: '/excludedExpenses',
    //         },
    //         {
    //           id: 38,
    //           class: 'hidden',
    //           title: this.$t('conciliation.status.missing'),
    //           href: '/missingExpenses',
    //         },
    //       ],
    //     },
    //     {
    //       class: '',
    //       title: this.$t('general.reports'),
    //       icon: 'fa fa-file-alt',
    //       child: [
    //         {
    //           id: 22,
    //           class: 'hidden',
    //           title: this.$t('expenseDetailEmployee.nameEmployees'),
    //           icon: 'filter_list',
    //           href: '/expenseDetailEmployee',
    //         },
    //         {
    //           id: 23,
    //           class: 'hidden',
    //           title: this.$t('general.reportsType'),
    //           icon: 'folder_special',
    //           href: '/reportsType',
    //         },
    //         {
    //           id: 26,
    //           class: 'hidden',
    //           title: this.$t('reportsByConcept.name'),
    //           icon: 'people',
    //           href: '/reportsByConcept',
    //         },
    //         {
    //           id: 24,
    //           class: 'hidden',
    //           title: this.$t('annualExpensesReport.name'),
    //           icon: 'calendar_today',
    //           href: '/annualExpensesReport',
    //         },
    //         {
    //           id: 25,
    //           class: 'hidden',
    //           title: this.$t('annualExpensesByEmployedReport.name'),
    //           href: '/annualExpensesByEmployedReport',
    //         },
    //         {
    //           id: 31,
    //           class: 'hidden',
    //           title: this.$t('reportExpenseTracking.name'),
    //           href: '/report-expenseTracking',
    //         },
    //         {
    //           id: 27,
    //           class: 'hidden',
    //           title: this.$t('reportComparative.name'),
    //           href: '/report-comparative',
    //         },
    //       ],
    //     },
    //     {
    //       icon: 'fa fa-file-download',
    //       title: this.$t('general.xmlDownload'),
    //       href: '/sat-xml-download',
    //       class: '',
    //     },
    //     {
    //       icon: 'fa fa-tasks',
    //       title: this.$t('general.verifyEFOS'),
    //       href: '/verifyEFOS',
    //       class: '',
    //     },
    //     {
    //       icon: 'fa fa-cog',
    //       title: this.$t('general.settings'),
    //       href: '/settings',
    //       class: '',
    //     },
    //     {
    //       icon: 'fa fa-power-off',
    //       title: this.$t('general.logout'),
    //       href: '/logout',
    //     },
    //   ]
    // },
    rootMenu() {
      return [
        {
          icon: 'fa fa-home',
          title: this.$t('general.home'),
          href: '/dashboard',
        },
        {
          icon: 'fa fa-bell',
          title: this.$t('general.notifications'),
          href: '/notifications',
        },
        {
          class: '',
          icon: 'fa fa-envelope',
          title: this.$t('general.contacts'),
          href: '/contact',
        },
        {
          user: ['ADMIN', 'EMPLOYEE'],
          icon: 'fa fa-building',
          class: '',
          title: this.$t('general.adminPanel'),
          child: [
            {
              class: 'submenu__child',
              icon: 'fa fa-cogs',
              title: this.$t('general.configGeneral'),
              href: '/general-config',
            },
            // Mis gastos
            {
              class: 'submenu__child',
              icon: 'fa fa-hand-holding-usd',
              title: this.$t('general.myExpensesNew'),
              child: [
                {
                  id: 17,
                  class: '',
                  title: this.$t('general.history'),
                  icon: 'history',
                  href: '/history',
                },
              ],
            },
          ],
        },

        {
          icon: 'fa fa-power-off',
          title: this.$t('general.logout'),
          href: '/logout',
        },
        {
          icon: 'fa fa-question',
          title: this.$t('general.helpCenter'),
          href: '/help-center',
        },
      ]
    },
    adminMenu() {
      return [
        {
          icon: 'fa fa-home',
          title: this.$t('general.home'),
          href: '/dashboard',
        },
        {
          icon: 'fa fa-bell',
          title: this.$t('general.notifications'),
          href: '/notifications',
        },
        {
          icon: 'fa fa-user',
          title: this.$t('general.userPanel'),
          child: [
            {
              class: 'submenu__child',
              icon: 'fa fa-hand-holding-usd',
              title: this.$t('general.myExpensesNew'),
              child: [
                {
                  id: 16,
                  class: '',
                  title: this.$t('general.expenses'),
                  icon: 'attach_money',
                  href: '/expenses',
                },
                {
                  id: 21,
                  class: '',
                  title: this.$t('general.rejected'),
                  href: '/rejected_expenses',
                },
                // {
                //   id: 19,
                //   class: '',
                //   title: this.$t('general.approbed'),
                //   href: '/approved_expenses',
                // },
                {
                  id: 17,
                  class: '',
                  title: this.$t('general.history'),
                  icon: 'history',
                  href: '/history',
                },
              ],
            },

            {
              class: 'submenu__child',
              icon: 'fa fa-file-invoice-dollar',
              title: this.$t('viatics.title'),
              href: '/expensesRequest',
            },
            // Solicitud de caja chica
            {
              class: 'submenu__child',
              icon: 'fa fa-wallet',
              title: this.$t('pettyCash.requestPettyCash'),
              href: '/request-pettyCash',
            },
            // Mi reporte detallado: se agrega al final para no recorrer los
            // índices que usa filteredMenu() sobre este child.
            {
              class: 'submenu__child',
              icon: 'fa fa-file-alt',
              title: this.$t('expenseDetailEmployee.myDetailReport'),
              href: '/myExpenseDetail',
            },
          ],
        },
        {
          user: ['ADMIN', 'EMPLOYEE'],
          icon: 'fa fa-building',
          class: '',
          title: this.$t('general.adminPanel'),
          child: [
            {
              class: 'submenu__child',
              icon: 'fa fa-cogs',
              title: this.$t('general.configGeneral'),
              href: '/general-config',
            },

            // Aprobaciones
            {
              // id: 20,
              icon: 'far fa-check-circle',
              class: 'submenu__child',
              title: this.$t('general.check'),
              // href: '/validate_expenses',
              child: [
                {
                  id: 20,
                  class: '',
                  title: this.$t('general.validateExpenses'),
                  href: '/validate_expenses',
                },
                {
                  id: 40,
                  class: '',
                  title: this.$t('general.validateRequest'),
                  href: '/approvals/validate-request',
                },
                {
                  id: 40,
                  class: '',
                  title: this.$t('general.validateRequestPettyCash'),
                  href: '/approvals/validate-request-petty-cash',
                },
              ],
            },
            // Opciones de gastos
            {
              class: 'submenu__child',
              title: this.$t('general.expenseOptions'),
              icon: 'fa fa-money-check-alt',
              child: [
                {
                  id: 34,
                  class: '',
                  title: this.$t('pettyCash.title'),
                  icon: 'attach_money',
                  href: '/pettyCash',
                },
                {
                  id: 34,
                  class: '',
                  title: this.$t('amexCard.title'),
                  icon: 'attach_money',
                  href: '/amexCard',
                },
                {
                  id: 32,
                  class: '',
                  title: this.$t('general.advances'),
                  icon: 'attach_money',
                  href: '/advances',
                },
                {
                  id: 28,
                  class: '',
                  title: this.$t('general.payable'),
                  href: '/expensesPayable',
                },
                {
                  id: 30,
                  class: '',
                  title: this.$t('ExpensesPaid.name'),
                  href: '/expensesPaid',
                },
              ],
            },
            // Conciliaciones
            {
              icon: 'fa fa-handshake',
              title: this.$t('general.conciliations'),
              class: 'submenu__child',
              child: [
                {
                  id: 35,
                  class: '',
                  title: this.$t('conciliation.status.toConciliate'),
                  href: '/toReconcileExpenses',
                },
                {
                  id: 36,
                  class: '',
                  title: this.$t('conciliation.status.conciliated'),
                  href: '/reconciledExpenses',
                },
                {
                  id: 37,
                  class: '',
                  title: this.$t('conciliation.status.excluded'),
                  href: '/excludedExpenses',
                },
                {
                  id: 38,
                  class: '',
                  title: this.$t('conciliation.status.missing'),
                  href: '/missingExpenses',
                },
              ],
            },
            // Reservaciones
            {
              icon: 'fa fa-file-invoice-dollar',
              title: this.$t('expenses.reservations.title'),
              class: 'submenu__child',
              child: [
                {
                  class: '',
                  title: this.$t('expenses.reservations.simple'),
                  href: '/reservations/checks',
                },
                {
                  class: '',
                  title: this.$t('expenses.reservations.request'),
                  href: '/reservations/application',
                },
                {
                  id: 60,
                  class: '',
                  title: this.$t('general.missingReserveExpenses'),
                  href: '/missingReserveExpenses',
                },
                {
                  id: 41,
                  class: '',
                  title: this.$t('representatives.title'),
                  href: '/representatives',
                },
              ],
            },
            {
              class: 'submenu__child',
              title: this.$t('general.reports'),
              icon: 'fa fa-file-alt',
              href: '/general-reports',
              // child: [
              //   {
              //     id: 22,
              //     class: '',
              //     title: this.$t('expenseDetailEmployee.nameEmployees'),
              //     icon: 'filter_list',
              //     href: '/expenseDetailEmployee',
              //   },
              //   {
              //     id: 23,
              //     class: '',
              //     title: this.$t('general.reportsType'),
              //     icon: 'folder_special',
              //     href: '/reportsType',
              //   },
              //   {
              //     id: 26,
              //     class: '',
              //     title: this.$t('reportsByConcept.name'),
              //     icon: 'people',
              //     href: '/reportsByConcept',
              //   },
              //   {
              //     id: 24,
              //     class: '',
              //     title: this.$t('annualExpensesReport.name'),
              //     icon: 'calendar_today',
              //     href: '/annualExpensesReport',
              //   },
              //   {
              //     id: 25,
              //     class: '',
              //     title: this.$t('annualExpensesByEmployedReport.name'),
              //     href: '/annualExpensesByEmployedReport',
              //   },
              //   {
              //     id: 31,
              //     class: '',
              //     title: this.$t('reportExpenseTracking.name'),
              //     href: '/report-expenseTracking',
              //   },
              //   {
              //     id: 27,
              //     class: '',
              //     title: this.$t('reportComparative.name'),
              //     href: '/report-comparative',
              //   },
              // ],
            },
            {
              icon: 'fa fa-file-download',
              title: this.$t('general.xmlDownload'),
              href: '/sat-xml-download',
              class: 'submenu__child',
            },
            {
              icon: 'fa fa-tasks',
              title: this.$t('general.verifyEFOS'),
              href: '/verifyEFOS',
              class: 'submenu__child',
            },
          ],
        },

        {
          icon: 'fa fa-power-off',
          title: this.$t('general.logout'),
          href: '/logout',
        },
        {
          icon: 'fa fa-question',
          title: this.$t('general.helpCenter'),
          href: '/help-center',
        },
      ]
    },
    userMenu() {
      return [
        {
          icon: 'fa fa-home',
          title: this.$t('general.home'),
          href: '/dashboard',
        },
        {
          icon: 'fa fa-bell',
          title: this.$t('general.notifications'),
          href: '/notifications',
        },
        {
          user: ['ADMIN', 'EMPLOYEE'],
          icon: 'fa fa-user',
          title: this.$t('general.userPanel'),
          child: [
            {
              class: 'submenu__child',
              icon: 'fa fa-hand-holding-usd',
              title: this.$t('general.myExpensesNew'),
              child: [
                {
                  id: 16,
                  class: '',
                  title: this.$t('general.expenses'),
                  icon: 'attach_money',
                  href: '/expenses',
                },
                {
                  id: 21,
                  class: '',
                  title: this.$t('general.rejected'),
                  href: '/rejected_expenses',
                },
                // {
                //   id: 19,
                //   class: '',
                //   title: this.$t('general.approbed'),
                //   href: '/approved_expenses',
                // },
                {
                  id: 17,
                  class: '',
                  title: this.$t('general.history'),
                  icon: 'history',
                  href: '/history',
                },
              ],
            },

            {
              class: 'submenu__child',
              icon: 'fa fa-file-invoice-dollar',
              title: this.$t('viatics.title'),
              href: '/expensesRequest',
            },
            {
              // id: 20,
              icon: 'far fa-check-circle',
              class: 'submenu__child',
              title: this.$t('general.check'),
              child: [
                {
                  id: 20,
                  class: '',
                  title: this.$t('general.validateExpenses'),
                  href: '/validate_expenses',
                },
                {
                  id: 40,
                  class: '',
                  title: this.$t('general.validateRequest'),
                  href: '/approvals/validate-request',
                },
                {
                  id: 40,
                  class: '',
                  title: this.$t('general.validateRequestPettyCash'),
                  href: '/approvals/validate-request-petty-cash',
                },
              ],
            },
            // Reservaciones
            {
              icon: 'fa fa-file-invoice-dollar',
              title: this.$t('expenses.reservations.title'),
              class: 'submenu__child hidden',
              child: [
                {
                  class: '',
                  title: this.$t('expenses.reservations.simple'),
                  href: '/reservations/checks',
                },
                {
                  class: '',
                  title: this.$t('expenses.reservations.request'),
                  href: '/reservations/application',
                },
                {
                  id: 60,
                  class: '',
                  title: this.$t('general.missingReserveExpenses'),
                  href: '/missingReserveExpenses',
                },
                {
                  id: 41,
                  class: '',
                  title: this.$t('representatives.title'),
                  href: '/representatives',
                },
              ],
            },
            {
              icon: 'fa fa-handshake',
              title: this.$t('general.conciliations'),
              class: 'submenu__child',
              child: [
                {
                  id: 37,
                  class: '',
                  title: this.$t('conciliation.status.excluded'),
                  href: '/excludedExpenses',
                },
                {
                  id: 38,
                  class: '',
                  title: this.$t('conciliation.status.missing'),
                  href: '/missingExpenses',
                },
              ],
            },
            // Solicitud de caja chica y Mi reporte detallado: se agregan al final
            // para no recorrer los índices que usa filteredMenu() sobre este child.
            {
              class: 'submenu__child',
              icon: 'fa fa-wallet',
              title: this.$t('pettyCash.requestPettyCash'),
              href: '/request-pettyCash',
            },
            {
              class: 'submenu__child',
              icon: 'fa fa-file-alt',
              title: this.$t('expenseDetailEmployee.myDetailReport'),
              href: '/myExpenseDetail',
            },
          ],
        },
        {
          icon: 'fa fa-power-off',
          title: this.$t('general.logout'),
          href: '/logout',
        },
        {
          icon: 'fa fa-question',
          title: this.$t('general.helpCenter'),
          href: '/help-center',
        },
      ]
    },
  },
  methods: {
    // Muestra u oculta las opciones del menú cuyo href venga en la lista.
    // Guarda la clase original porque userLogged llega vacío al inicio: cuando
    // ya se conocen los features hay que poder volver a mostrar la opción.
    toggleMenuItemsByHref(nodes, hrefs, visible) {
      nodes.forEach((node) => {
        if (hrefs.indexOf(node.href) !== -1) {
          if (node.defaultClass === undefined) node.defaultClass = node.class
          node.class = visible ? node.defaultClass : 'hidden'
        }
        if (node.child) this.toggleMenuItemsByHref(node.child, hrefs, visible)
      })
    },
    onItemClick(event, item) {
      if (item.href === '/logout') {
        this.$store.dispatch('logout', {})
      }
    },
    toggleBodyClass(className) {
      const el = document.body
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    toggleSidebarHover(add, className) {
      const el = document.body
      this.sidebarActive = !this.sidebarActive

      this.windowWidth = document.documentElement.clientWidth

      if (this.windowWidth > '992') {
        if (add === 'add') {
          el.classList.add(className)
        } else {
          el.classList.remove(className)
        }
      }
    },
    getWindowWidth() {
      const el = document.body

      this.windowWidth = document.documentElement.clientWidth

      if (this.windowWidth < '1350') {
        el.classList.add('closed-sidebar', 'closed-sidebar-md')
      } else {
        el.classList.remove('closed-sidebar', 'closed-sidebar-md')
      }
    },
    filteredMenu() {
       // let menu = this.menu
      // let options = this.userLogged.roles[0].permissions
      // for (let i = 0; i < menu.length; i++) {
      //   if (menu[i].child !== undefined) {
      //     let items = menu[i].child
      //     for (let j = 0; j < items.length; j++) {
      //       if (options !== undefined) {
      //         options.forEach((item) => {
      //           if (item.id === items[j].id) {
      //             items[j].class = ''
      //           }
      //         })
      //       }
      //     }
      //     if (items.find((item) => item.class === '')) {
      //       menu[i].class = ''
      //     } else {
      //       menu[i].class = 'hidden'
      //     }
      //   }
      // }
      // // --- Super Admin Options --- //
      // if (this.userLogged.roles[0].id === 1) {
      //   menu[2].class = ''
      // }
      // // --- Validator/Substitute/Approber Options --- //
      // if (
      //   this.userLogged.substitute !== null ||
      //   this.userLogged.validator !== null ||
      //   this.userLogged.approvers !== null
      // ) {
      //   // menu[6].child[2].class = ''
      //   menu[7].class = ''
      //   menu[7].child[0].class = ''
      //   menu[7].child[1].class = ''
      // } else {
      //   menu[7].class = 'hidden'
      //   // menu[6].child[2].class = 'hidden'
      // }
      // if (this.userLogged.approvers !== null) {
      //   menu[8].child[3].class = ''
      // } else {
      //   menu[8].child[3].class = 'hidden'
      // }
      // // --- General Admin Options --- //
      // if (this.userLogged.roles[0].id === 2) {
      //   menu[9].class = ''
      //   menu[10].class = ''
      //   menu[11].class = ''
      //   menu[12].class = ''
      //   menu[8].child[4].class = ''
      //   menu[9].child[0].class = ''
      //   menu[9].child[1].class = ''
      //   menu[9].child[2].class = ''
      // } else {
      //   menu[9].class = 'hidden'
      //   menu[10].class = 'hidden'
      //   menu[11].class = 'hidden'
      //   menu[12].class = 'hidden'
      //   // menu[4].child[6].class = 'hidden'
      //   menu[8].child[4].class = 'hidden'
      //   menu[9].child[0].class = 'hidden'
      //   menu[9].child[1].class = 'hidden'
      //   menu[9].child[2].class = 'hidden'
      //   menu[9].child[3].class = 'hidden'
      // }

      // // --- Hide Configuration Employee User --- //
      // if (this.userLogged.roles[0].id === 3) {
      //   menu[4].class = 'hidden'
      //   menu[8].class = 'hidden'
      //   // menu[8].child[4].class = ''
      //   // menu[8].child[2].class = 'hidden'
      //   menu[9].class = ''
      //   menu[9].child[1].class = ''
      //   menu[9].child[3].class = ''
      //   menu[12].class = 'hidden'
      //   menu[13].class = 'hidden'
      // }
      // // Hide reconciliation module for users without AMEX card except for ADMIN users
      // if (
      //   (this.userLogged.card_number !== null &&
      //     this.userLogged.card_number !== '') ||
      //   this.userLogged.roles[0].id === 2
      // ) {
      //   menu[9].class = ''
      // } else {
      //   menu[9].class = 'hidden'
      // }

      // // Permisos para cajeros
      // if (this.userLogged.cashiers.length > 0) {
      //   this.menu[8].class = ''
      //   this.menu[8].child[2].class = 'hidden'
      //   this.menu[8].child[4].class = ''
      // }
      const typeUser = this.userLogged.roles[0].name
      const isCashier = this.userLogged.cashier
    
      // Ojo: los índices dependen del orden de userMenu[2].child ("Panel usuario"):
      // 0 "Mis gastos", 1 "Solicitud de gastos", 2 "Aprobaciones",
      // 3 "Reservaciones", 4 "Conciliaciones", 5 "Caja chica"
      if (typeUser === 'EMPLOYEE') this.menu = this.userMenu
      if (typeUser === 'EMPLOYEE' && isCashier) this.menu[2].child[3].class = 'submenu__child' // "Reservaciones"
      if (typeUser === 'EMPLOYEE' && this.userLogged && !this.userLogged.card_number) {
        this.menu[2].child[4].class = 'hidden' // "Conciliaciones"
        this.menu[2].child[4].child[0].class = 'hidden' // "Excluidos"
        this.menu[2].child[4].child[1].class = 'hidden' // "Faltantes"
      }

      if(typeUser === 'EMPLOYEE'){
        
        if(this.userLogged.validator !== null || this.userLogged.substitute !== null || this.userLogged.approvers !== null) {
          const updateNodeClass = (nodes, title, titleEnglish, newClass) => {
            for (let node of nodes) {
                if (node.title === title || node.title === titleEnglish) {
                    node.class = newClass
                    node.class = 'submenu__child'
                    if (node.child) {
                        node.child.forEach(child => child.class = newClass);
                    }
                } else if (node.child) {
                    updateNodeClass(node.child, title, newClass);
                }
            }
        };

        updateNodeClass(this.menu, "Reservaciones", "Reservations", "hidden");
        }

        if(this.userLogged.validator === null && this.userLogged.approvers === null) this.menu[2].child[2].child[0].class = 'hidden' // "Aprobaciones" > "Validar gastos"
      }

      if (typeUser === 'ADMIN') this.menu = this.adminMenu
      if (typeUser === 'SUPER ADMIN') this.menu = this.rootMenu

      // Solicitud de caja chica y su validación dependen del feature de la empresa.
      this.toggleMenuItemsByHref(
        this.menu,
        ['/request-pettyCash', '/approvals/validate-request-petty-cash'],
        this.applyFeaturePettyCashRequests
      )

      this.filtered = true
      this.$nextTick(() => {
        this.$refs.prueba.$children.forEach((e) => {
          const typeUser = this.userLogged.roles[0].name
          if (typeUser === 'ADMIN' && e.item.user) e.item.class = ''

          if (e.item.user && e.item.user.includes(typeUser)) {
            e.emitActiveShow(e._uid)
          }
        })
      })
    },
  },
  watch: {
    '$i18n.locale'(){
      this.filteredMenu()
    },
    userLogged() {
      this.filteredMenu()
    },
    menu() {
      this.filteredMenu()
    },
  },
  beforeCreate() {
    if (this.$store.userState === undefined) {
      this.$store.dispatch('userLogged', { event: { context: this } })
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)

      // Init
      this.getWindowWidth()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
}
</script>

<style>
.vsm-icon {
  height: 1em !important;
  margin-top: 0 !important;
  top: 5px !important;
}
.v-sidebar-menu .vsm-item {
  padding: 0 !important;
}
.vsm-item a.hidden {
  display: none;
}

.vsm-item a.hidden {
  display: none;
}

.submenu__child > .vsm-icon {
  height: 1rem !important;
}

.submenu__child > span {
  padding-left: 2rem;
}
/* .vsm-item:not(.first-item) .vsm-link .vsm-title
{
  left: 25px;
} */
</style>



// WEBPACK FOOTER //
// src/Layout/Components/Sidebar.vue